import { gql } from '@apollo/client'

export default gql(`
query($assetId: ID! $project: String) {
  listPublishRules( 
    id: $assetId
    project: $project
    ){
      id
      assetId
      group{
        id
      }
      isEnabled
      publishEndDate
      publishStartDate
      }
}`)
